import { TreeNodeTypes } from "../constants/ProConstants";
import _ from 'lodash'
import Services from "../service/ApiServices"
import { FormattedDateString, GetDate } from "../utilities/DateHelper";
import { MoveClientModel } from "../models/FormDataModel";
import {useHierarchyService} from "./useHierarchyService";


const useFormModelServices = ()=>{ 
   
   const {data:{currentLocation, parentsInHierarchy, parentTypes, parents, rooms}} =  useHierarchyService()

    const GetLevelType = (code)=>{
        var index = _.findIndex(TreeNodeTypes, (t)=>t.code === code);
        if(index >= 0){
            return TreeNodeTypes[index]
        }
        return {};
    }

    const GetSetupModel = async (node)=>{
        let model = {};              
        switch(node.type){
            case "BUILDING":               
                model =  (await Services.Setup.getBuildingById(node.id)).data; //DummyBuilding01;               
                break;
            case "BED":
                model= (await Services.Setup.getBedById(node.id)).data; 
                break;
            case "FLOOR":
            case "UNIT": 
            case "WING":
            case "ROOM":               
                model = (await Services.Setup.getIntermediateById(node.type, node.id)).data //DummyFloor01;
                break; 
            default:               
                break;
        }
        return {type: GetLevelType(node.type), model: model};
    }

    const GetCensusModel = async (data)=>{
        let model = null;
        if(_.get(data, "assignmentId")){
            model = (await Services.Census.getBedAssignmentData(data.assignmentId)).data;
            model = {...model, startDate:GetDate(model.startDate), endDate: GetDate(model.endDate)}
          
        }
        return model;

    }

    const InitializeMoveClient = (model)=>{ 

            const buildingData =  _.find(parentsInHierarchy, (o) => { return o.type === "BUILDING"; })           
            const parentType = _.find(parentTypes, (o)=>{return o.key === parentsInHierarchy[1].type})
            const parent = _.intersectionBy(parentsInHierarchy, parents, 'key')      
            const room = _.intersectionBy(parentsInHierarchy, rooms, "key") 
          
            model = _.merge(model , {...MoveClientModel
                                     ,location:currentLocation
                                     ,building:buildingData
                                     ,parentType: parentType
                                     ,parent: parent.length===1? parent[0]: null
                                     ,room: room.length === 1? room[0]: null 
                                     ,bed: null})
            return model;
         }

   

    const GetDetails = async (node, date, assignmentData, action)=>{         
        switch(action)
        {
            case "VIEW_BED":
                return (await Services.Census.getBedDetailsByIdAndDate(node.id, {date: FormattedDateString(date)})).data
            case "BED_HISTORY":
                return (await Services.Census.getBedOccupantHistory(node.id)).data
            case "CLIENT_HISTORY":
               return (await Services.Census.getClientBedHistory(assignmentData.client.id)).data
            default:
                return null;
        }
    }
    

    return {GetSetupModel, GetCensusModel, GetDetails, InitializeMoveClient };
}


export default useFormModelServices;